@if (isSkeleton) {
    <!-- Raia fantasma: mesma caixa da raia real, conteudo em loading-box. -->
    <div class="pv-raia" aria-hidden="true">
        <div class="pv-raia-header pv-raia--skeleton">
            <app-loading-box height="28" width="28"></app-loading-box>
            <app-loading-box height="12" width="140"></app-loading-box>
            <app-loading-box height="20" width="24"></app-loading-box>
            <app-loading-box height="11" width="88"></app-loading-box>
        </div>

        <div class="pv-raia-colunas">
            @for (coluna of raia.colunas; track coluna.idEtapaKanban) {
                <app-pv-coluna [coluna]="coluna" [isSkeleton]="true"></app-pv-coluna>
            }
        </div>
    </div>
} @else if (raia.isRecolhida) {
    <!-- Raia recolhida: tira vertical estreita com o nome girado e o contador. -->
    <button
        type="button"
        class="pv-raia-recolhida"
        [style.border-top-color]="raia.cor.principal"
        (click)="recolherRaia.emit(raia)"
        [matTooltip]="'Expandir ' + raia.nome">
        <mat-icon class="material-symbols-outlined pv-raia-chevron">chevron_right</mat-icon>
        <!-- Mesmo chip do cabeçalho aberto: recolher a raia não muda a identidade dela. -->
        <span class="pv-raia-icone" [style.background]="raia.cor.fundo" [style.color]="raia.cor.conteudo">
            <mat-icon class="material-symbols-outlined">{{ raia.nomeIcone }}</mat-icon>
        </span>
        <span class="pv-raia-nome-vertical" [style.color]="raia.cor.conteudo">{{ raia.nome }}</span>
        <span class="pv-raia-badge">{{ totalDaRaia }}</span>
    </button>
} @else {
    <div class="pv-raia">
        <button
            type="button"
            class="pv-raia-header"
            [style.border-bottom-color]="raia.cor.principal"
            (click)="recolherRaia.emit(raia)"
            matTooltip="Recolher raia">
            <span
                class="pv-raia-icone"
                [style.background]="raia.cor.fundo"
                [style.color]="raia.cor.conteudo">
                <mat-icon class="material-symbols-outlined">{{ raia.nomeIcone }}</mat-icon>
            </span>

            <span class="pv-raia-nome" [style.color]="raia.cor.conteudo">{{ raia.nome }}</span>

            <!-- Contador e soma do processo. As faixas não somam: os documentos delas já
                 entram no total do processo, e repetir aqui pareceria dois somatórios. -->
            @if (raia.totalCards != null) {
                <span class="pv-raia-badge">{{ raia.totalCards }}</span>
            }
            @if (raia.somaValorTotal != null && isMostrarSoma) {
                <span class="pv-raia-soma">{{ raia.somaValorTotal | abnt: 'preco' : 2 }}</span>
            }

            @if (raia.isSomenteLeitura) {
                <span
                    class="pv-raia-selo"
                    [matTooltip]="
                        'O pedido não é manipulado aqui. Estas colunas apenas mostram que ele está sendo processado por uma rotina externa ao Kanban — para tratar a separação ou a expedição, acesse a rotina específica.'
                    ">
                    <mat-icon class="material-symbols-outlined">info</mat-icon>
                    somente leitura
                </span>
            }

            <span class="pv-raia-spacer"></span>

            <mat-icon class="material-symbols-outlined pv-raia-recolher">keyboard_double_arrow_left</mat-icon>
        </button>

        <div class="pv-raia-colunas">
            @for (coluna of raia.colunas; track coluna.idEtapaKanban) {
                <app-pv-coluna
                    [coluna]="coluna"
                    [isMostrarSoma]="isMostrarSoma"
                    [isSomenteLeitura]="raia.isSomenteLeitura"
                    [aceitaCard]="aceitaCard"
                    [podeArrastar]="podeArrastar"
                    [podeInserir]="podeInserir"
                    [podeExcluir]="podeExcluir"
                    [podeLancarFinanceiro]="podeLancarFinanceiro"
                    [podeExcluirFinanceiro]="podeExcluirFinanceiro"
                    [podeLancarEstoque]="podeLancarEstoque"
                    [podeExcluirEstoque]="podeExcluirEstoque"
                    [cardEmArraste]="cardEmArraste"
                    (arrasteIniciou)="arrasteIniciou.emit($event)"
                    (arrasteTerminou)="arrasteTerminou.emit()"
                    (ponteiroEntrou)="ponteiroEntrou.emit($event)"
                    (recolher)="recolherColuna.emit($event)"
                    (verMais)="verMais.emit($event)"
                    (abrirCard)="abrirCard.emit($event)"
                    (moverCard)="moverCard.emit($event)"
                    (criarModelo)="criarModelo.emit($event)"
                    (clonar)="clonar.emit($event)"
                    (verHistorico)="verHistorico.emit($event)"
                    (verOportunidadesCliente)="verOportunidadesCliente.emit($event)"
                    (excluir)="excluir.emit($event)"
                    [permissoesOportunidade]="permissoesOportunidade"
                    (verOportunidade)="verOportunidade.emit($event)"
                    (criarOportunidade)="criarOportunidade.emit($event)"
                    (vincularOportunidade)="vincularOportunidade.emit($event)"
                    (desvincularOportunidade)="desvincularOportunidade.emit($event)"
                    (lancarFinanceiro)="lancarFinanceiro.emit($event)"
                    (excluirFinanceiro)="excluirFinanceiro.emit($event)"
                    (lancarEstoque)="lancarEstoque.emit($event)"
                    (excluirEstoque)="excluirEstoque.emit($event)"
                    (verFinanceiro)="verFinanceiro.emit($event)"></app-pv-coluna>
            }
        </div>
    </div>
}
